import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { bimIncludeContractObjectToWorkOrderGql } from '../../bimWorkOrderQueries';

const requestId = 'bimIncludeContractObjectToWorkOrder';

export const useBimIncludeContractObjectToWorkOrder = (workOrderId?: number) => {
    const dispatch = useDispatch();

    const [
        bimIncludeContractObjectToWorkOrderData,
        bimIncludeContractObjectToWorkOrderStatus,
        bimIncludeContractObjectToWorkOrderError,
        bimIncludeContractObjectToWorkOrderRequest,
    ] = useRequest({
        requestId,
        query: bimIncludeContractObjectToWorkOrderGql,
        withEffect: false,
    });

    const [bimIncludeContractObjectToWorkOrderReset] = useResetStoreData({ requestId });

    const bimIncludeContractObjectToWorkOrderMakeRequest = useCallback(
        (contractObjectId: number) => {
            dispatch(bimIncludeContractObjectToWorkOrderRequest({ contractObjectId, workOrderId }));
        },
        [bimIncludeContractObjectToWorkOrderRequest, dispatch, workOrderId],
    );

    return {
        bimIncludeContractObjectToWorkOrderReset,
        bimIncludeContractObjectToWorkOrderData,
        bimIncludeContractObjectToWorkOrderStatus,
        bimIncludeContractObjectToWorkOrderError,
        bimIncludeContractObjectToWorkOrderMakeRequest,
    };
};
